@use "../../mixins" as *;
@use "../../variables" as *;

.filter-group-container {
  .headline {
    cursor: pointer;
    font-size: 1.125rem;
    line-height: 1.125rem;
    padding-bottom: 0.5rem;
    margin-top: 2.25rem;
    margin-bottom: 0.75rem;
    border-bottom: 1px solid $grey-lighter;

    display: flex;
    justify-content: space-between;

    svg {
      fill: $grey;
      width: 0.875rem;
      height: 0.875rem;

      @include tablet {
        width: 1rem;
        height: 1rem;
      }
    }
  }

  .filter-group {
    overflow: hidden;
    transition: all 0.3s ease-in-out;

    max-height: 0;

    &.expanded {
      // the value of 'max-height' needs to be increased when web categories/filters are added
      // fit-content breaks the animation for collapsing/ expanding filters
      max-height: 1100px;
    }
  }
}
